import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerWebMcpTools } from './webmcp/tools';
import './index.css';

// Before the first render: agents and agent-readiness scanners look for WebMCP tools at page load.
registerWebMcpTools();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
